import React, { Component } from "react";
import { logoutUser } from "../modules/actions";
import { getUserData } from "../modules/reducers";
import { connect } from "react-redux";
import { withRouter, NavLink } from 'react-router-dom';
import { compose } from "redux";
import { ROLE_MENU_MAP, SIDEBAR_PAGES } from "../constants";

const activeStyle = {
  fontWeight: 'bold',
  color: '#fff'
};

class Sidebar extends Component {
    constructor() {
        super();
        const isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';
        this.state = {
            collapsed: isCollapsed
        };
        if (isCollapsed) {
            document.body.classList.add('sidebar-collapsed');
        } else {
            document.body.classList.remove('sidebar-collapsed');
        }
    }

    componentDidMount() {
        window.addEventListener('toggle-sidebar', this.toggleSidebar);
    }

    componentWillUnmount() {
        window.removeEventListener('toggle-sidebar', this.toggleSidebar);
    }

    toggleSidebar = () => {
        this.setState({ collapsed: !this.state.collapsed }, () => {
            localStorage.setItem('sidebarCollapsed', this.state.collapsed);
            if (this.state.collapsed) {
                document.body.classList.add('sidebar-collapsed');
            } else {
                document.body.classList.remove('sidebar-collapsed');
            }
        });
    };

    logoutUser = () => {
        this.props.logout();
        this.props.history.push('/');
    };

    renderMenu = () => {
        const { user } = this.props;
        const allowedMenus = ROLE_MENU_MAP[user.role] || [];

        return (
            <>
                {allowedMenus.includes("Test Generator") && (
                    <div className="modern-menu-item">
                        <a
                            data-bs-toggle="collapse"
                            href="#sidebarTestGenerator"
                            aria-expanded={SIDEBAR_PAGES["Test Generator"].includes(this.props.act) ? true : false}
                            aria-controls="sidebarTestGenerator"
                            className={`modern-menu-link ${SIDEBAR_PAGES["Test Generator"].includes(this.props.act) ? 'active' : ''}`}
                        >
                            <i className="uil-clipboard-alt"></i>
                            <span>Test Generator</span>
                            <i className="mdi mdi-chevron-down menu-arrow"></i>
                        </a>
                        <div className={`collapse ${SIDEBAR_PAGES["Test Generator"].includes(this.props.act) ? 'show' : ''}`} id="sidebarTestGenerator">
                            <div className="modern-submenu">
                                <NavLink to="/books" activeStyle={activeStyle} isActive={(match) => match || this.props.act === 'books'}>Books</NavLink>
                                <NavLink to="/subjects" activeStyle={activeStyle} isActive={(match) => match || this.props.act === 'subjects'}>Subjects</NavLink>
                                <NavLink to="/schools" activeStyle={activeStyle} isActive={(match) => match || this.props.act === 'schools'}>Schools</NavLink>
                            </div>
                        </div>
                    </div>
                )}

                {allowedMenus.includes("Sales App") && (
                    <div className="modern-menu-item">
                        <a
                            data-bs-toggle="collapse"
                            href="#sidebarSalesApp"
                            aria-expanded={SIDEBAR_PAGES["Sales App"].includes(this.props.act) ? true : false}
                            aria-controls="sidebarSalesApp"
                            className={`modern-menu-link ${SIDEBAR_PAGES["Sales App"].includes(this.props.act) ? 'active' : ''}`}
                        >
                            <i className="dripicons-user-group"></i>
                            <span>Sales App</span>
                            <i className="mdi mdi-chevron-down menu-arrow"></i>
                        </a>
                        <div className={`collapse ${SIDEBAR_PAGES["Sales App"].includes(this.props.act) ? 'show' : ''}`} id="sidebarSalesApp">
                            <div className="modern-submenu">
                                <NavLink to="/salesManagers" activeStyle={activeStyle} isActive={(match) => match || this.props.act === 'salesManagers'}>Sales Managers</NavLink>
                                <NavLink to="/schoolsData" activeStyle={activeStyle} isActive={(match) => match || this.props.act === 'schoolsData'}>Schools Data</NavLink>
                                <NavLink to="/distributors" activeStyle={activeStyle} isActive={(match) => match || this.props.act === 'distributors'}>Distributors</NavLink>
                                <NavLink to="/salesDailyReport" activeStyle={activeStyle} isActive={(match) => match || this.props.act === 'salesDailyReport'}>Daily Report</NavLink>
                                <NavLink to="/salesReport" activeStyle={activeStyle} isActive={(match) => match || this.props.act === 'salesReport'}>Attendance Report</NavLink>
                                <NavLink to="/leaveRequests" activeStyle={activeStyle} isActive={(match) => match || this.props.act === 'leaveRequests'}>Leave Requests</NavLink>
                            </div>
                        </div>
                    </div>
                )}

                {allowedMenus.includes("ELP") && (
                    <div className="modern-menu-item">
                        <a
                            data-bs-toggle="collapse"
                            href="#sidebarELP"
                            aria-expanded={SIDEBAR_PAGES["ELP"].includes(this.props.act) ? true : false}
                            aria-controls="sidebarELP"
                            className={`modern-menu-link ${SIDEBAR_PAGES["ELP"].includes(this.props.act) ? 'active' : ''}`}
                        >
                            <i className="uil-clipboard-alt"></i>
                            <span>ELP</span>
                            <i className="mdi mdi-chevron-down menu-arrow"></i>
                        </a>
                        <div className={`collapse ${SIDEBAR_PAGES["ELP"].includes(this.props.act) ? 'show' : ''}`} id="sidebarELP">
                            <div className="modern-submenu">
                                <NavLink to="/classes" activeStyle={activeStyle} isActive={(match) => match || this.props.act === 'classes' || this.props.act === 'elpChapters'}>Classes</NavLink>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };

    render() {
        return (
            <div className={`modern-sidebar ${this.state.collapsed ? 'collapsed' : ''}`}>
                <div className="modern-sidebar-header">
                    <div className="sidebar-user-avatar">
                        <i className="mdi mdi-account"></i>
                    </div>
                    <div className="sidebar-user-name">{this.props.user.username}</div>
                </div>
                <div className="modern-sidebar-content">
                    <div className="modern-sidebar-title">Managed Apps</div>
                    {this.renderMenu()}
                </div>
                <div className="modern-sidebar-footer">
                    <button className="modern-logout-btn" onClick={(e) => this.logoutUser()}>
                        <i className="mdi mdi-logout"></i>
                        <span>Logout</span>
                    </button>
                    <div className="sidebar-copyright">
                        © Dachepalli Publications {new Date().getFullYear()}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: getUserData(state), // Ensure role is included in user data
});

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(logoutUser()),
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Sidebar);
